import { Request } from 'api';
import { AxiosResponse } from 'axios';

interface ScrapeRequest {
    url: string;
    group_uuid: string;
}

interface ScrapeResponse {
    job_id: string;
    status: string;
    message: string;
}

type ReturnType = Promise<AxiosResponse<ScrapeResponse>>;

const scrapeTrackEvents = (data: ScrapeRequest): ReturnType => {
    return Request.post('/workouts/track-events/scrape', data);
};

export default scrapeTrackEvents;
